const TOKEN_KEY = "token"
const LEGACY_GQL_TOKEN_KEY = "gqltoken"

function readStoredToken(key) {
  var saved = localStorage.getItem(key)
  if (!saved) {
    return null
  }

  try {
    return JSON.parse(saved)
  } catch (e) {
    return saved
  }
}

const Auth = {
  /**
   * Reads the session JWT for Apollo. Uses the same key as angular-storage (REST login).
   * Falls back to legacy gqltoken for users with an active session before this change.
   */
  getToken: () => {
    return readStoredToken(TOKEN_KEY) || localStorage.getItem(LEGACY_GQL_TOKEN_KEY)
  },

  onLogout: () => {
    localStorage.removeItem(LEGACY_GQL_TOKEN_KEY)
  }
}

export default Auth
